var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99 16.04a.754.754 0 0 1 0-1.06l3.05-3.05c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.05 3.05c-.15.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.07 16.07-3.05-3.05a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.05 3.05c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM12.53 14c0-.55.44-1 .99-1h.02c.55 0 1 .45 1 1s-.44 1-1 1c-.55 0-1.01-.45-1.01-1zM16.47 14c0-.55.44-1 .99-1h.02c.55 0 1 .45 1 1s-.45 1-1 1-1.01-.45-1.01-1zM14.5 15.98v-.02c0-.55.45-1 1-1s1 .45 1 1-.44 1.01-1 1.01c-.55 0-1-.44-1-.99zM14.5 12.04v-.02c0-.55.45-1 1-1s1 .45 1 1-.44 1.01-1 1.01c-.55 0-1-.44-1-.99z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75v-2c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v2c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 13v2c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-2c0-4.61-1.64-6.25-6.25-6.25H9c-4.61 0-6.25 1.64-6.25 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.99 6.75c-.96 0-1.75-.79-1.75-1.75s.78-1.75 1.74-1.75c.16 0 .27-.11.28-.25l.01-1.01c.01-.41.34-.74.75-.74h.01c.41.01.75.35.74.76l-.01 1.01c-.01.95-.8 1.73-1.75 1.73-.16 0-.26.11-.26.25s.11.25.25.25h1c.41 0 .75.34.75.75s-.35.75-.76.75h-1z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGame);
export default __webpack_public_path__ + "static/media/vuesax-outline-game.94ee420b59f252fa17bbe0c09692fe94.svg";
export { ForwardRef as ReactComponent };